export default __webpack_public_path__ + "img/eogDwEqw.474edd72.svg";